import "../../../application/components/addresses_map.js";

const MARKER_ICON_URL = window.SparkleConfig.physicianProfile.useProfilePictureMarker
  ? window.SparkleConfig.assetPaths.mapPinSvg
  : null;
const MARKER_WIDTH = 50;
const MARKER_HEIGHT = 60;

Sparkle.Views.PhysicianProfileMap = class PhysicianProfileMap extends Sparkle.Views.AddressesMap {
  constructor(options) {
    super(options);
    this.getMarkerOptions = this.getMarkerOptions.bind(this);
    if (options == null) {
      options = {};
    }
    this.iconUrl = options.iconUrl || MARKER_ICON_URL;
  }

  getMarkerOptions(address) {
    const markerOptions = super.getMarkerOptions(address);

    if (this.iconUrl) {
      markerOptions["icon"] = {
        url: this.iconUrl,
        scaledSize: new google.maps.Size(MARKER_WIDTH, MARKER_HEIGHT),
      };
    }

    return markerOptions;
  }
};
